import cn from 'bem-cn';

import { User as YandexUser } from '@yandex-lego/user';
import { useUserContext } from '../../../contexts';

import { RoutePaths } from '../../../constants';

import { Icon, Link, Stack } from '../../UI';
import { ScreenSize, useGetScreenSize } from '../../../hooks';

import { usePassportLink } from './HeaderProfile.hooks';
import { HeaderProfileProps } from './HeaderProfile.types';
import './HeaderProfile.scss';

const b = cn('header');

export const HeaderProfile = (props: HeaderProfileProps) => {
    const { className, isLightColors } = props;

    const { user } = useUserContext();

    const screenSize = useGetScreenSize();
    const isMobile = screenSize === ScreenSize.Mobile;
    const avatarSize: [number, number] = isMobile ? [32, 32] : [40, 40];

    const passportLink = usePassportLink();

    return (
        <div className={b('profile').mix(className)}>
            {user.isAuth ? (
                <Stack spacing={isMobile ? 24 : 32} direction="row" alignItems="center">
                    <Link to={RoutePaths.ProfilePrompts}>
                        <Stack spacing={8} direction="row" alignItems="center" className={b('link')}>
                            <Icon name="terminal" size={24} />
                            <p>Профиль</p>
                        </Stack>
                    </Link>
                    <YandexUser fetchUserData avatarSize={avatarSize} />
                </Stack>
            ) : (
                <a className={b('auth-button', { white: isLightColors })} href={passportLink}>
                    Войти
                </a>
            )}
        </div>
    );
};
